import React from "react";
import { Route, Switch } from "react-router-dom";
import enquiries from "./enquiries";
import products from "./products";
import users from "./users";
import websiteQueries from "./websiteQueries";
import myProfile from "./myProfile";
import promotions from "./promotions";
import registartions from "./registartions";
import policyUpdates from "./policyUpdates";
import promotionBroadcast from "./promotionBroadcast";
import navigationDetails from "./navigationDetails";
import freightBooking from "./freightratesApprove";
import exporterPortPair from "./exporterPortPairs"
import offerYourCargoAdmin from "./offerYourCargoAdmin"
import buyerEnquiries from "./buyerEnquiries";
import UserProfile from "../routes/userProfile/UserProfile";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}enquiries`} component={enquiries} />
      <Route path={`${match.url}products`} component={products} />
      <Route path={`${match.url}users`} component={users} />
      <Route path={`${match.url}website-queries`} component={websiteQueries} />
      <Route path={`${match.url}my-profile`} component={myProfile} />
      <Route path={`${match.url}promotions`} component={promotions} />
      <Route path={`${match.url}registrations`} component={registartions} />
      <Route path={`${match.url}policy-updates`} component={policyUpdates}/>
      <Route path={`${match.url}broadcast-promotions`} component={promotionBroadcast} />
      <Route path={`${match.url}freight-bookings`} component={freightBooking} />
      <Route path={`${match.url}navigation-reports`} component={navigationDetails} />
      <Route path={`${match.url}exporter-port-pair`} component={exporterPortPair}/>
      <Route path={`${match.url}offer-your-cargo-admin`} component={offerYourCargoAdmin}/>
      <Route path={`${match.url}buyer-enquiries`} component={buyerEnquiries}/>
      <Route path={`${match.url}user-profile`} component={UserProfile} />
    </Switch>
  </div>
);

export default React.memo(App);
